
import { IoOptionsOutline } from 'react-icons/io5';
import { ListPanelWrapper } from '../../../components/ListPaneWrapper';
import { VscPassFilled } from 'react-icons/vsc';
import { themedUseStyletron } from '../../../../theme/customTheme';


export function ListPanel(props: any) {
    const [css, theme] = themedUseStyletron();
    return (
        <ListPanelWrapper icon={<IoOptionsOutline size={'100%'}  color={theme.colors.backgroundPrimary}></IoOptionsOutline>} {...props}>
            <VscPassFilled color={props.request?theme.appColors.aggregate.on:theme.appColors.aggregate.off} size={theme.sizing.scale800}></VscPassFilled>
        </ListPanelWrapper>
    );
}